import ContactUs from '@/app/contact'

export default ContactUs
